import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { setNonce } from '@ionic/core/loader';
import { addIcons } from 'ionicons';
import { informationCircle } from 'ionicons/icons';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

addIcons({
  'information-circle': informationCircle,
});

const cspNonce = document
  .querySelector('[ngCspNonce]')
  ?.getAttribute('ngCspNonce')
  ?.trim();

if (cspNonce) {
  setNonce(cspNonce);
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
